<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-alert-circle-outline
      </v-icon> Edit Support Ticket
    </h2>
    <v-card
      class="my-base-vcard-style"
    >
      <br>
      <v-card class="my-vcard-style">
        <v-form
          ref="form"
          v-model="isFormValid"
        >
          <v-container class="py-0">
            <v-row class="text-center">
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="ticketName"
                  label="Ticket Name*"
                  hint="Name for your reference - 'No-Display' (Only alpha dashes allowed)."
                  :rules="[(v) => !!v || 'This field is required']"
                  @keydown.space.prevent
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="OrganizationId"
                  label="Organization Id*"
                  :rules="[(v) => !!v || 'This field is required']"
                  hint="Name for your reference - 'DBSYS'"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="clientReferenceNumber"
                  label="Client Reference Number"
                  hint="Reference number prefered by the client."
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="internalReferenceNumber"
                  label="Internal Reference Number"
                  hint="Reference number from jira."
                />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="selectedType"
                  :items="type"
                  label="Select Type*"
                  :rules="rules.select"
                  menu-props="auto"
                  prepend-icon="mdi-select"
                  @change="isTypeCms"
                />
              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <v-autocomplete
                  ref="typeCheck"
                  v-model="selectedDigiBoardId"
                  :items="digiBoards"
                  item-value="external_id"
                  item-text="external_id"
                  label="Select Device"
                  prepend-icon="mdi-television"
                  hint="Select the device location, only if your issue type is related to a device."
                  :disabled="disableDigiBoard"
                  persistent-hint
                />
              </v-col>
            </v-row>
            <br>
            <v-textarea
              v-model="issueDescription"
              filled
              label="Description about the issue*"
              :rules="[(v) => !!v || 'This field is required']"
            />
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="reportedBy"
                  label="Reported By*"
                  :rules="[(v) => !!v || 'This field is required']"
                  hint="External id of the reported user."
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="currentStatus"
                  :items="statusItems"
                  label="Select Current Status"
                  menu-props="auto"
                  prepend-icon="mdi-select"
                />
              </v-col>
            </v-row>
          </v-container>
          <br>
          <p class="p-style">
            *Indicates required field
          </p>
        </v-form>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="close()"
          >
            Back
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="update()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>

<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'SupportForm',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        isFormValid: false,
        ticketName: '',
        issueDescription: '',
        selectedDigiBoardId: null,
        selectedType: '',
        reportedBy: '',
        type: ['cms', 'device'],
        OrganizationId: '',
        internalReferenceNumber: null,
        clientReferenceNumber: null,
        currentStatus: '',
        statusItems: ['open', 'inProgress', 'parked', 'done'],
        rules: {
          select: [(v) => !!v || 'This field is required'],
        },
        loading: false,
      };
    },
    computed: {
      digiBoards () {
        return this.$store.getters['digiboards/getDigiBoardsList'];
      },
      disableDigiBoard () {
        if (this.selectedType === 'cms') {
          return true;
        }
        return false;
      },
      ticketContent () {
        return this.$store.getters['support/getTicketContent'];
      },
    },
    async mounted () {
      await this.fillData();
      this.$store.dispatch('digiboards/fetchDigiBoardsList');
    },
    methods: {
      async fillData () {
        this.loading = true;
        const TicketId = this.$route.params.id;
        await this.$store.dispatch('support/fetchTicketContent', {
          id: TicketId,
        });
        this.ticketName = this.ticketContent.name;
        this.OrganizationId = this.ticketContent.organization_id;
        this.selectedType = this.typeGetter(this.ticketContent.type);
        this.selectedDigiBoardId = this.ticketContent.digi_board_id;
        this.clientReferenceNumber = this.ticketContent.client_reference;
        this.issueDescription = this.ticketContent.description;
        this.internalReferenceNumber = this.ticketContent.internal_reference
          ? this.ticketContent.internal_reference : 'N/A';
        this.reportedBy = this.ticketContent.user_id;
        this.currentStatus = this.ticketContent.status;
        this.loading = false;
      },
      async update () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('support/updateIssueTicket', {
            name: this.ticketName,
            type: this.typeMapper(),
            digi_board_id: this.selectedDigiBoardId,
            description: this.issueDescription,
            client_reference: this.clientReferenceNumber,
            internal_reference: this.internalReferenceNumber,
            organization_id: this.OrganizationId.toUpperCase(),
            reported_by: this.reportedBy.toUpperCase(),
            status: this.currentStatus,
            id: this.$route.params.id,
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Ticket updated successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.close();
          });
        }
      },
      close () {
        this.$router.push({ name: 'Support Tickets' });
        this.ticketName = '';
        this.issueDescription = '';
        this.selectedDigiBoardId = null;
        this.clientReferenceNumber = null;
        this.internalReferenceNumber = null;
        this.OrganizationId = '';
        this.reportedBy = '';
        this.selectedType = '';
      },
      isTypeCms () {
        if (this.selectedType === 'cms') {
          this.$refs.typeCheck.reset();
        }
      },
      typeMapper () {
        if (this.selectedType === 'device') {
          return 'digiBoard';
        }
        return 'cms';
      },
      typeGetter (type) {
        if (type === 'digiBoard') {
          return 'device';
        }
        return 'cms';
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-vcard-style {
  margin-right: 30px;
  margin-left: 30px;
  background-color: #ECEFF1;
  border-radius: 25px;
}
.my-base-vcard-style {
  background-color: #CFD8DC !important;
}
.p-style {
  margin-left: 10px;
}
</style>
